import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { handleLogout } from "../../redux/reducers/authReducer";
import styles from "../../assets/css/modules/logoutModal.module.css";

const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

export default function LogoutModal({ isOpen, onClose }) {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();

  const handleConfirm = () => {
    dispatch(handleLogout());
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Icon Badge */}
        <div className={styles.iconBadge}>
          <LogoutIcon />
        </div>

        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>
            {language === "ar" ? "تسجيل الخروج" : "Sign Out"}
          </h2>
          <p className={styles.subtitle}>
            {language === "ar"
              ? "هل أنت متأكد من رغبتك في تسجيل الخروج من حسابك؟ ستحتاج إلى إعادة تسجيل الدخول للوصول مرة أخرى."
              : "Are you sure you want to sign out? You will need to log back in to access your account."}
          </p>
        </div>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <button className={styles.btnCancel} onClick={onClose}>
            {language === "ar" ? "إلغاء" : "Cancel"}
          </button>
          <button className={styles.btnConfirm} onClick={handleConfirm}>
            {language === "ar" ? "تسجيل الخروج" : "Sign Out"}
          </button>
        </div>
      </div>
    </div>
  );
}
